<template>
	<v-card flat class="">
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" class="elevation-1">
			<template v-slot:top>
				<v-toolbar flat>

					<v-toolbar-title>Jadwal Praktik</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-select v-model="table.status" outlined hide-details="" dense label="Status :"
						:items="table.statuss" @change="getDataFromApi()"></v-select>
				</v-toolbar>
			</template>
			<template v-slot:item.institusi="{ item }">
				{{ item.nama_institusi }}/ {{ item.nama_prodi }}
			</template>
			<template v-slot:item.stase="{ item }">
				{{ item.nama_stase }}, {{ item.stase }}
			</template>
			<template v-slot:item.file_url="{ item }">
				<embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'" width="500"
					height="300" />
				<br /><a target="_blank" :href="item.file_url">Lihat
					File</a>
			</template>
			<template v-slot:item.actions="{ item }">
				<span v-if="item.flag_end == 0">Aktif</span>
				<span v-else>Non Aktif</span>

				<router-link :to="{ name: 'PembimbingLogbook', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Logbook</v-btn>
				</router-link>
				<router-link :to="{ name: 'PembimbingVerifikasiDaftar', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Verifikasi Daftar Hadir</v-btn>
				</router-link>
				<router-link :to="{ name: 'PembimbingVerifikasiLogbook', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Verifikasi Logbook</v-btn>
				</router-link>
				<router-link :to="{ name: 'PembimbingVerifikasiTingkat', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Verifikasi Tingkat Supervisi</v-btn>
				</router-link>
				<router-link
					v-if="item.profesi == 'Dokter' || item.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'"
					:to="{ name: 'PembimbingVerifikasiUjian', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Verifikasi Ujian</v-btn>
				</router-link>
				<router-link v-if="item.profesi == 'Dokter'"
					:to="{ name: 'PembimbingEvaluasiDokter', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link>
				<router-link v-else-if="item.profesi == 'PPDS'"
					:to="{ name: 'PembimbingEvaluasiPPDS', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link>
				<router-link v-else-if="item.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'"
					:to="{ name: 'PembimbingEvaluasiLain', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link>

				<router-link v-if="item.profesi == 'PPDS'"
					:to="{ name: 'PembimbingVerifikasiTargetKompetensi', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Target Kompetensi</v-btn>
				</router-link>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi" x-small>
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil } from '@mdi/js'

export default {
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil,
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{
					text: 'No',
					align: 'start',
					sortable: false,
					value: 'no',
				},
				{ text: 'Institusi/ Prodi', value: 'institusi' },
				{ text: 'Kelompok', value: 'profesi' },
				{ text: 'Stase', value: 'stase' },
				{ text: 'File', value: 'file_url', sortable: false },
				{ text: 'Status/ Aksi', value: 'actions' },
			],
			items: [],
			totalItems: 0,
			status: 'Aktif',
			statuss: ['Aktif', 'Non Aktif']
		},
		dialog: false,
		// dialogDelete: false,
		form: {
			editedIndex: -1,
			editedItem: {
				id_institusi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			defaultItem: {
				id_prodi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			profesis: [
				'Dokter',
				'PPDS',
				'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain',
			],
			stases: [],
		},
		institusi_pendidikans: [],
		prodis: [],
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	methods: {
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('search', '')
			fmData.append('status', this.table.status)
			axiosPostAuth('api/Pembimbing/getPraktik_datatable', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
	},
}
</script>